import FormAutoOrder from './FormAutoOrder';

export default FormAutoOrder;
